import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_INVOICE_REPORT } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const invoicingReport = {
  namespaced: true,
  state: buildInitialState({
    invoicingReport: [
      {
        clientBillingSummaries: {
          clientId: null,
          clientName: null,
          billingSummaries: []
        },
        dateBegin: null,
        dateEnd: null,
        invoiceFrequencyId: null,
        totalRevenue: null
      }
    ]
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    clearInvoicingReport: (state) => {
      state.invoicingReport = [
        {
          billingSummaries: [],
          dateBegin: null,
          dateEnd: null,
          invoiceFrequencyId: null,
          totalRevenue: null
        }
      ]
    },
    setInvoicingReport: (state, invoicingReport) => {
      state.invoicingReport = invoicingReport
    }
  },
  actions: {
    getInvoicingReport: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting invoicing data, please wait...' })

      return api.doGet({ path: PATH_INVOICE_REPORT, parameters: filters })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          commit('setInvoicingReport', data)
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get invoicing data')
          return null
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getInvoicingReportWithFilters: ({ dispatch, rootGetters }) => {
      return dispatch('getInvoicingReport', { ...rootGetters['invoicingReportFilters/getSearchObject'] })
    },
    clearInvoicingReport ({ commit }) {
      return commit('clearInvoicingReport')
    }
  }
}

export default invoicingReport
